import { isNotNullOrWhitespace, isNullOrWhitespace } from "./stringService";

export function getNextUrl(encounterId, encounter, selectedProgram) {
    switch (selectedProgram.eligibilityDeterminationStatus.name) {
        case "Pending Action": {
            if (isNotNullOrWhitespace(selectedProgram.supplementalInfoTemplate)) {
                return `/interview/${encounterId}/details/supplemental`;
            }

            if (selectedProgram.requiresPostSelectionApproval && selectedProgram.requestingUserCanApprove) {
                return `/interview/${encounterId}/details/approval`;
            } else {
                return `/interview/${encounterId}/details/dispatch`;
            }
        }
        case "Pending Supplemental Information": {
            if (selectedProgram.requiresPostSelectionApproval && selectedProgram.requestingUserCanApprove) {
                return `/interview/${encounterId}/details/approval`;
            } else {
                return `/interview/${encounterId}/details/dispatch`;
            }
        }
        case "Pending Decision": {
            if (selectedProgram.requestingUserCanApprove) {
                return `/interview/${encounterId}/details/dispatch`;
            } else {
                throw new Error(
                    "Invalid state. This page should only be accessible for users with permission to approve the program"
                );
            }
        }
    }
}
